import { useContext, useMemo } from 'react';
import useAppSelector from 'hooks/useAppSelector';
import {
  getVisibleSeasonalRules,
  VisibleSeasonalRule,
} from 'pages/calendar/common/seasonalRules/getVisibleSeasonalRules';
import CalendarContext from 'pages/virtualizedStackedCalendar/CalendarContext';
import { stackedCalendarStyleConstants } from 'pages/virtualizedStackedCalendar/Calendar.constants';

const useVisibleSeasonalRules = (
  propertyUid: string,
): VisibleSeasonalRule[] => {
  const rules = useAppSelector(
    (state) => state.stackedCalendar.propertySeasonalRulesMap[propertyUid],
  );
  const visibleDates = useAppSelector(
    (state) => state.stackedCalendar.visibleDates,
  );
  const { mode } = useContext(CalendarContext);
  const cellWidth = stackedCalendarStyleConstants.daysCellWidth[mode];

  return useMemo(
    () => getVisibleSeasonalRules({ rules, visibleDates, cellWidth }),
    [rules, visibleDates, cellWidth],
  );
};

export default useVisibleSeasonalRules;
